/**
 * 模型详情页级 Tab 常量与类型守卫。
 *
 * 独立成无副作用小模块：data-models/$id 路由壳的 validateSearch 需要
 * isModelDetailTab，若从 model-detail-tabs.tsx（组件模块，依赖
 * entity-editor → dagre 等）导入，整条组件依赖链会被静态拖进入口 chunk。
 */
/** 模型详情「详情」模式的页级 Tab;值同步到路由 search(?tab=),支持深链接 */
export const MODEL_DETAIL_TABS = [
  "entities",
  "relations",
  "constraints",
  "quality",
  "versions",
] as const;
export type ModelDetailTab = (typeof MODEL_DETAIL_TABS)[number];

export function isModelDetailTab(v: unknown): v is ModelDetailTab {
  return MODEL_DETAIL_TABS.some((t) => t === v);
}
